import React, { PureComponent } from "react";
import { PieChart, Pie } from "recharts";
const COLORS = ["#68BE5D", "#FE9F4C", '#B27AA1', '#4B9795', '#E3575A', '#6A8299', '#EBD165'];

export default class RegionalPieChart extends PureComponent {

    constructor() {
        super();
        this.state = {
            toggleData: [],
            arr: []
        };
    }

    componentDidMount(){
        this.calculateValue(this.props.data);
    }

    calculateValue = (value) => {
        if (value) {
            let newArr = []
            value.forEach((element,ind) => {
                newArr.push({ name: element.Name, value: parseInt((element.Percentage)?.toFixed(0)),fill:COLORS[ind] })
            });
            this.setState({
                arr:newArr
            })
        }
    }

    renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value, index }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.7;
     const x  = cx + radius * Math.cos(-midAngle * RADIAN);
     const y = cy  + radius * Math.sin(-midAngle * RADIAN);
    
     return (
       <text x={x} y={y} fill="white" textAnchor={'middle'} dominantBaseline="central">
           {`${value?.toFixed(0)}%`}
       </text>
     );
   };

    render() {

        return (
            <PieChart width={130} height={130}>
                <Pie
                    data={this.state.arr}
                    cx={60}
                    cy={60}
                    labelLine={false}
                      label={this.renderCustomizedLabel}
                    outerRadius={55}
                    fill={this.state.arr.fill}
                >
                </Pie>
            </PieChart>
        );
    }
};